import { createRoot } from 'react-dom/client';
import SpecialDealsHero from './App.jsx';
function mount() {
  const container = document.getElementById('special-deals-hero-root');
  if (!container) return;
  const showcase = container.dataset.showcase ? JSON.parse(container.dataset.showcase) : undefined;
  createRoot(container).render(<SpecialDealsHero showcase={showcase} />);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
else mount();
